<template>
  <v-layout
    row
    wrap
    fill-height
  >
    <v-card
      class="mx-auto align-self-center"
      color="white"
      elevation-1
      hover
      width="400"
    >
      <v-card-title>
        <h1 class="primary--text font-weight-regular mx-auto">
          Recuperar Contraseña
        </h1>
      </v-card-title>

      <v-text-field
        v-model="document"
        class="mx-4"
        label="Documento"
      />

      <v-text-field
        v-model="email"
        class="mx-4"
        label="Email"
      />

      <v-card-actions>
        <v-layout
          row
          wrap
        >
          <v-btn
            :disabled="checkDisabled"
            :loading="loading"
            class="primary ma-3"
            block
            @click="recoverPassword"
          >
            Enviar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
import { recuperarPassword } from '../api/userEndpoints'

export default {
  name: 'PasswordRecoveryView',
  data () {
    return {
      loading: false,
      menu: false,
      document: null,
      email: null
    }
  },
  computed: {
    checkDisabled () {
      return !this.email || !this.document
    }
  },
  methods: {
    async recoverPassword () {
      const user = {
        documento: this.document,
        email: this.email
      }
      this.loading = true
      const recoveredPassword = await recuperarPassword(user)
      this.loading = false
      if (recoveredPassword.respuesta === 'ERROR') {
        this.$createAlert({
          message: recoveredPassword.mensaje,
          type: 'error',
          duration: 5000
        })
      } else {
        this.$createAlert({
          message: recoveredPassword.mensaje,
          type: 'success',
          duration: 3000
        })
        this.$router.replace({ name: 'LoginView' })
      }
    }
  }
}
</script>

<style scoped lang="sass">
  .progress-circle
    margin: 40vh auto
</style>
